<template>
  <div>
    <template v-if="formEditorEnabled">
      <el-dialog
          :visible.sync="editDialog"
          top="4vh"
          :show-close="false">
        <s-auto-form
            :fillHeight="false"
            @close="editDialog = false"
            @change="
            $emit('cell-input', { row: editRowData });
            $emit('row-input', editRowData);
            editDialog = false;
          "
            :displayValProcessor="displayVal"
            v-model="editRowData"
            :colDefinitions="colDefinitionsProcessed"></s-auto-form>
      </el-dialog>
    </template>

    <el-table

        :fit="!!optimalHeight"
        :show-header="showHeader"
        :default-sort="{ prop: defaultSort, order: 'descending' }"
        :current-row-key="rowKeyField"
        ref="stable"

        empty-text="-"
        :key="clock"
        v-loading="initloading"
        :data="dataWindow"
        :height="optimalHeight"
        style="width: 100%"
        border
        @cell-click="notifyForClick"
        @sort-change="reload"
        @table-scroll="lazyLoadScroll"
        :row-class-name="selectionClass"
        :cell-class-name="preCellClassFactory"
        @selection-change="handleSelectionChange"

        @select-all="realAll">

      <el-table-column
          width="30"
          prop="visability"
          label="*"
          v-if="formEditorEnabled"
          fixed="left">
        <template slot-scope="scope">
          <div
              :idx="scope.row.idx"
              :style="
              'width:100%;' +
                (scope.row.height ? 'height:' + scope.row.height + 'px;' : '')
            ">
            <el-button
                icon="el-icon-edit"
                type="text"
                @click="editRow(scope)"></el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          type="expand"
          v-if="expandComponent">
        <template slot-scope="props">
          <component
              :is="expandComponent"
              v-model="props.row"></component>
        </template>
      </el-table-column>

      <el-table-column
          width="60"
          prop="visability"
          label="*"
          v-if="dispalyLineNumber || sortingProp ">
        <template #header>
          <slot name="top-left"></slot>
        </template>
        <template slot-scope="scope">

          <div
              :idx="scope.row.idx"
              :style="
              'width:100%;' +
                (scope.row.height ? 'height:' + scope.row.height + 'px;' : '')
            "
              @drop="dropRow($event, scope.row)"
              @dragover.prevent
              @dragenter.prevent>
            <span> {{ scope.row.idx }}</span>
            <span
                class="drag-and-drop-col"
                v-if="sortingProp"
                draggable
                @dragstart="moveRow($event, scope.row)">
              <i
                  class="el-icon-s-unfold"
                  v-if="
                  !!transportRow &&
                    transportRow[rowKeyField] != scope.row[rowKeyField]
                "></i>
              <i
                  class="el-icon-rank"
                  v-else></i>
            </span>
          </div>

        </template>
      </el-table-column>
      <el-table-column
          v-if="mobileMode"
          prop="idx">
        <template slot-scope="scope">
          <div
              v-for="(colprops, idx) in colDefinitionsProcessed"
              v-bind="colprops"
              sortable="custom"
              :key="idx"
              class="responsive-field">
            <div
                :title="colprops.title"
                :style="
                'width:100%;' +
                  (scope.row.height ? 'height:' + scope.row.height + 'px;' : '')
              "
                :ref="scope.row.idx + '_cell_' + idx">
              <div :key="moundKey + idx">
                <template v-if="isEditState(colprops, {row:scope.row,column:colprops})">
                  <small style="float: left">{{
                      colprops.mLabel || colprops.mLabel === ""
                          ? colprops.mLabel
                          : colprops.label
                    }}
                  </small>
                  <component
                      :is="colprops.editorcomponent.is"
                      v-if="colprops.editorcomponent"
                      v-bind="colprops.editorcomponent"
                      v-table-focus-navigator="[
                      editingCoord,
                      scope,
                      colDefinitionsProcessed,
                      allwaysEdit
                    ]"
                      @click="
                      notifyForClickMobile(scope.row, colprops, 0, $event)
                    "
                      v-model="scope.row[colprops.prop]"
                      @change="handleCellChange($event, colprops, scope);"
                      @input="
                      emitInput({
                        prop: colprops.prop,
                        row: scope.row
                      })
                    "></component>

                  <component
                      @click="
                      notifyForClickMobile(scope.row, colprops, 0, $event)
                    "
                      v-else-if="colprops.editorcomponentFactory"
                      :is="colprops.editorcomponentFactory(scope.row).is"
                      v-bind="colprops.editorcomponentFactory(scope.row)"
                      v-table-focus-navigator="[
                      editingCoord,
                      scope,
                      colDefinitionsProcessed,
                      allwaysEdit
                    ]"
                      v-model="scope.row[colprops.prop]"
                      @change="handleCellChange($event, colprops, scope);"
                      @input="
                      emitInput({
                        prop: colprops.prop,
                        row: scope.row
                      })
                    "></component>
                  <el-input
                      v-else
                      :placeholder="colprops.placeholder"
                      v-table-focus-navigator="[
                      editingCoord,
                      scope,
                      colDefinitionsProcessed,
                      allwaysEdit
                    ]"
                      v-model="scope.row[colprops.prop]"
                      @change="handleCellChange($event, colprops, scope);
                    "
                      @input="
                      emitInput({
                        prop: colprops.prop,
                        row: scope.row
                      })
                    "></el-input>
                </template>

                <template v-else>
                  <small style="float: left">{{
                      colprops.mLabel || colprops.mLabel === ""
                          ? colprops.mLabel
                          : colprops.label
                    }}
                  </small>
                  <div
                      @click="
                      notifyForClickMobile(scope.row, colprops, 0, $event)
                    "
                      :title="colprops.title"
                      :class="
                      (canBeEdit(colprops, scope)
                        ? 'editable r-cell'
                        : 'no-edit  r-cell ') +
                        (noWrap ? ' nowrap' : 'wrapwords')+' '+(colprops.isClickable?'clickable':'')
                    ">
                    <component
                        v-if="colprops.viewcomponent"
                        :is="colprops.viewcomponent.is"
                        v-bind="colprops.viewcomponent"
                        v-model="scope.row[colprops.prop]"
                        :rowdata="scope.row"></component>
                    <s-cell
                        v-else
                        :colprops="colprops"
                        @execute="
                        $emit(
                          'cell-clicked',
                          e.alterClick ? { alterClick: true, ...scope } : scope
                        )
                      "
                        :islink="
                        linkFactory(
                          scope.row[colprops.prop],
                          colprops,
                          scope.row
                        )
                      ">
                      <div
                          v-if="
                          colprops.action != 'button' ||
                            (colprops.disableClick &&
                              colprops.disableClick(scope.row))
                        "
                          v-html="
                          displayVal(
                            scope.row[colprops.prop],
                            colprops,
                            scope.row
                          )
                        "></div>

                      <s-button
                          size="mini"
                          :type="colprops.buttonType"
                          class="supermini"
                          v-else-if="colprops.action == 'button'"
                          v-html="
                          displayVal(
                            scope.row[colprops.prop],
                            colprops,
                            scope.row
                          )
                        "></s-button>
                    </s-cell>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <template v-else>
        <el-table-column
            class-name="selecter"
            v-if="selectStorage"
            width="41px">
          <template
              slot="header"
              slot-scope="scope">
            <el-button
                style="padding:0px;width:20px"
                class="selecter"
                @click="selectInStorage()"
                :icon="justSelectedAll?'el-icon-success':'el-icon-circle-check'"
                type="text"></el-button>
          </template>
          <template slot-scope="scope">
            <el-button
                style=" width:20px"
                class="selecter"
                @click="selectInStorage(scope.row)"
                :icon="justSelectedAll||scope.row._selected||isSelectedInStorage(scope.row)?'el-icon-success':'el-icon-circle-check'"
                type="text"></el-button>
          </template>
        </el-table-column>
        <el-table-column

            v-for="(colprops, idx) in colDefinitionsProcessed"
            v-bind="colprops"
            :sortable="(!$slots['top-right']||(!!$slots['top-right']&&idx!=colDefinitionsProcessed.length-1))&&colprops.sortable !== false ? 'custom' : false"
            :key="idx"
            :fixed="colprops.fixed ? colprops.fixed : false">
          <template
              slot="header"
              slot-scope="scope">
            <template

                v-if="!!$slots['top-right']&&idx==colDefinitionsProcessed.length-1">
              <slot name="top-right"></slot>
            </template>
            <template v-else>
          <span
              v-if="colprops.elIcon"
              :title="colprops.label"><i :class="colprops.elIcon"></i></span>
              <span
                  v-html="colprops.label"
                  v-else></span>
            </template>
          </template>

          <template slot-scope="scope">
            <div
                :title="colprops.title"
                :style="
              'width:100%;' +
                (scope.row.height ? 'height:' + scope.row.height + 'px;' : '')
            "
                :ref="scope.row.idx + '_cell_' + idx">
              <div :key="moundKey + idx">
                <template v-if="isEditState(colprops, scope)">
                  <component
                      :is="colprops.editorcomponent.is"
                      v-if="colprops.editorcomponent"
                      v-bind="colprops.editorcomponent"
                      v-table-focus-navigator="[editingCoord,scope,colDefinitionsProcessed,allwaysEdit]"
                      v-model="scope.row[scope.column.property]"
                      @change="handleCellChange($event, colprops, scope);"
                      @input="
                    emitInput({ prop: scope.column.property, row: scope.row })
                  "></component>
                  <component
                      v-else-if="colprops.editorcomponentFactory"
                      :is="colprops.editorcomponentFactory(scope.row,tableData).is"
                      v-bind="colprops.editorcomponentFactory(scope.row,tableData)"
                      v-table-focus-navigator="[
                    editingCoord,
                    scope,
                    colDefinitionsProcessed,
                    allwaysEdit
                  ]"
                      v-model="scope.row[scope.column.property]"
                      @change="handleCellChange($event, colprops, scope);"
                      @input="
                    emitInput({ prop: scope.column.property, row: scope.row })
                  "></component>
                  <el-input
                      v-else
                      :placeholder="colprops.placeholder"
                      v-table-focus-navigator="[
                    editingCoord,
                    scope,
                    colDefinitionsProcessed,
                    allwaysEdit
                  ]"
                      v-model="scope.row[scope.column.property]"
                      @change="handleCellChange($event, colprops, scope);"
                      @input="
                    emitInput({ prop: scope.column.property, row: scope.row })
                  "></el-input>
                </template>

                <template v-else>
                  <div
                      class="r-cell"
                      :title="colprops.title"
                      :class="noWrap ? ' nowrap' : 'wrapwords'"
                      xclass="
                    (canBeEdit(colprops, scope)
                      ? 'editable r-cell'
                      : 'no-edit  r-cell ') + (noWrap ? ' nowrap' : 'wrapwords')
                  ">
                    <component
                        v-if="colprops.viewcomponent"
                        :is="colprops.viewcomponent.is"
                        v-bind="colprops.viewcomponent"
                        v-model="scope.row[scope.column.property]"
                        :rowdata="scope.row"></component>
                    <s-cell
                        v-else
                        :colprops="colprops"
                        @execute="
                      $emit(
                        'cell-clicked',
                        $event.alterClick ? { alterClick: true, ...scope } : scope
                      )
                    "
                        :islink="
                      linkFactory(
                        scope.row[scope.column.property],
                        colprops,
                        scope.row
                      )
                    ">
                      <div
                          v-if="
                        colprops.action != 'button' ||
                          (colprops.disableClick &&
                            colprops.disableClick(scope.row))
                      "
                          v-html="
                        displayVal(
                          scope.row[scope.column.property],
                          colprops,
                          scope.row
                        )
                      "></div>

                      <s-button
                          size="mini"
                          :type="colprops.buttonType"
                          class="supermini"
                          v-else-if="colprops.action == 'button'"

                          v-html="
                        displayVal(
                          scope.row[scope.column.property],
                          colprops,
                          scope.row
                        )
                      "></s-button>
                    </s-cell>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
// import mdl from "~/mixins/mdl";
// import { fetchList } from "~/api/resource";
import Vue from "vue";
// import InfiniteLoading from "vue-infinite-loading";
import * as api from "~/api/resource";
// import * as api from "~/api";
import SCell from "./SCell";
import {mapGetters, mapMutations} from "vuex";
import {apiGetCall} from "../../api/laravel";

function isDomElVisible(elem) {
  if (!(elem instanceof Element)) throw Error('DomUtil: elem is not an element.');

  // const style = getComputedStyle(elem);
  // // if (style.display === 'none') return false;
  // // if (style.visibility !== 'visible') return false;
  // // if (style.opacity < 0.1) return false;
  if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height +
      elem.getBoundingClientRect().width === 0) {
    return false;
  }
  const elemCenter = {
    x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
    y: elem.getBoundingClientRect().top + elem.offsetHeight / 2
  };
  if (elemCenter.x < 0) return false;
  if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) return false;
  if (elemCenter.y < 0) return false;
  if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) return false;
  let pointContainer = document.elementFromPoint(elemCenter.x, elemCenter.y);
  do {
    if (pointContainer === elem) return true;
  } while (pointContainer = pointContainer.parentNode);
  return false;
}

let lastStep = 0
export default {
  name: "STable",
  components: {
    SCell
  },

  directives: {
    tableFocusNavigator: {
      inserted: function (el, binding, vnode) {
        // _log_("NAV.goaeway.OOO..:", binding);
        if (binding.value[3] === true) {
          // _log_("NAV.goaeway.OOO..:", binding);
          // return true;
        }

        let vm = vnode.context,
            coordinates = binding.value[0],
            rowScope = binding.value[1],
            columns = binding.value[2],
            rowi = binding.value[3] ? binding.value[3] : rowScope.row.idx; //, wColname = rowScope.column.property;//colIndex = _.findIndex(columns, { prop: rowScope.column.property })
        var colIndex = vm.columnEditableIndex(rowScope, columns);
        if (vm.allwaysEdit) return;
        if (
            colIndex >= 0 &&
            coordinates.row == rowi &&
            coordinates.col == colIndex
        ) {
          Vue.nextTick(function () {
            let inputs = el ? el.getElementsByTagName("input") : null;

            // _log_("NAV.OOO..:", inputs);
            // let elel = vm.$refs['col_input' + rowScope.column.property]
            // // if (elel) elel[0].focus()
            // _log_('is ins..F.' + colIndex, elel[0])
            if (inputs && inputs[0]) {
              inputs[0].focus();
              inputs[0].addEventListener("keydown", f);
            }
          });
        }
        let f = function (evt) {
          _log_("is ins..FPRESS.", evt, coordinates);
          if (!evt) return;
          if (vm.allwaysEdit) {
            coordinates = vm.editingCoord;
          }
          if (evt.code == "Tab") {
            evt.preventDefault();
            evt.stopPropagation();
          }
          if (evt.ctrlKey && evt.code == "Enter") {
            vnode.child.$emit("execute-row", rowScope);
          }
          vnode.child.$emit("nav", evt);
          if (evt.ctrlKey && evt.code == "ArrowUp") {
            evt.preventDefault();
            evt.stopPropagation();
            if (coordinates.row > 0) --coordinates.row;
            vnode.child.$emit("nav-up", evt);
          }
          if ((evt.ctrlKey && evt.code == "ArrowRight") || evt.code == "Tab") {
            evt.preventDefault();
            evt.stopPropagation();
            if (vm.columnEditableCount(columns, rowScope) - 1 > coordinates.col)
              ++coordinates.col;
            else {
              // _log_('NAV.OOO..ln doi')
              coordinates.col = 0;
              ++coordinates.row;
            }
            vnode.child.$emit("nav-right", evt);
          }
          if (evt.ctrlKey && evt.code == "ArrowDown") {
            evt.preventDefault();
            evt.stopPropagation();
            ++coordinates.row;
            vnode.child.$emit("nav-down", evt);
          }
          if (evt.ctrlKey && evt.code == "ArrowLeft") {
            evt.preventDefault();
            evt.stopPropagation();
            if (coordinates.col > 0) --coordinates.col;
            else {
              if (coordinates.row > 0) --coordinates.row;
            }
            vnode.child.$emit("nav-right", evt);
          }
          vnode.child.$emit("key-pressed", evt);

          if (vm.allwaysEdit) {
            coordinates = vm.editingCoord;
            const elFocus =
                vm.$refs[vm.editingCoord.row + "_cell_" + vm.editingCoord.col];
            _log_(
                "COOOOcccs:",
                elFocus,
                vm.editingCoord,
                rowScope,
                coordinates
            );
            let inputs =
                elFocus && elFocus[0]
                    ? elFocus[0].getElementsByTagName("input")
                    : null;
            if (inputs && inputs.length) {
              _log_("NAV.OOO..:", inputs);
              // let elel = vm.$refs['col_input' + rowScope.column.property]
              // // if (elel) elel[0].focus()
              // _log_('is ins..F.' + colIndex, elel[0])
              inputs[inputs.length - 1].focus();
            }
            // inputs[inputs.length - 1].addEventListener("keydown", f);
          }
        };
        // let parentInputs = el.getElementsByTagName('input');
        // _log_('inputs...',parentInputs)
        // if (parentInputs.length) parentInputs[0].addEventListener("keydown", f);
        // else
        el.addEventListener("keydown", f);
      }
    }
  },
  props: {
    routeQueryPrefix: {
      type: String,
      default: null
    },
    oneLoad: {
      type: Boolean,
      default: false
    },
    autoClearStore: {
      type: Boolean,
      default: true
    },
    formEditorEnabled: {
      type: Boolean,
      default: false
    },
    addEmptyLineIfEmpty: {
      type: Boolean,
      default: false
    },
    dispalyLineNumber: {
      type: Boolean,
      default: false
    },
    selectStorage: {
      type: String,
      default: null
    },
    cellSelectionWithObjects: {
      type: Boolean,
      default: false
    },
    selectMode: {
      type: Boolean,
      default: false
    },
    visualise: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    noWrap: {
      type: Boolean,
      default: true
    },
    rowClassFactory: {
      type: Function,
      default: null
    },
    endPoint: {
      type: Function,
      default: null
    },
    editorcomponentFactory: {
      type: Function,
      default: null
    },
    selectable: {
      type: Function,
      default: null
    },
    cellClassFactory: {
      type: Function,
      default: null
    },
    editDisabled: {
      type: Boolean,
      default: false
    },
    selectionId: {
      default: null
    },
    rowKeyField: {type: String, default: "id"},
    selectedClass: {type: String, default: "selectedRow"},
    newClass: {type: String, default: "newRow"},
    mobileMode: {
      type: Boolean,
      default: false
    },
    allwaysEdit: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    laraProcessor: {
      type: String,
      default: null
    },
    modxProcessor: {
      type: String,
      default: null
    },

    outerRowHeight: {
      type: Number,
      default: 59 //30+2*8 padding+3borders
    },
    rowHeight: {
      type: Number,
      default: null
    },
    pagging: {
      type: Number,
      default: 40
    },
    maxRows: {
      type: Number,
      default: 2000
    },
    topOffset: {
      type: Number,
      default: 5
    },
    expandComponent: {
      type: String,
      default: null
    },
    rQuery: {
      type: Object,
      default: () => {
      }
    },
    newRowData: {
      type: Object,
      default: () => null
    },
    wakeUpPath: {
      type: String,
      default: null
    },
    sortingProp: {
      type: [String,
        Boolean],
      default: null
    },
    lazyLoader: {
      type: Boolean,
      default: true
    },
    simpleLazyLoader: {
      type: Boolean,
      default: false
    },
    addEmptyLine: {
      type: Boolean,
      default: false
    },
    colDefinitions: {
      type: Array,
      default: () => []
    },
    defaultSort: {
      type: String,
      default: null
    },
    heightWish: {
      type: [String,
        Boolean],
      default: "tobottom"
    }
  },
  data: function () {
    return {
      // controlQueryParams: {},
      editDialog: false,
      editRowData: null,
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: [0,
          1] //if you want a 25% offset!
      },
      editMode: false,
      SELECTWRAP_DOM: null,
      SELECTWRAP_DOM_BODY: null,
      lastQuery: null,
      hiddenRows: {},
      topIdx: 0,
      clock: 0,
      lastIdxClicked: null,
      gap: {top: 0, bottom: 0},
      archorInfinitState: null,
      moundKey: 1,
      justSelectedAll: false,
      // lastTopElement: null,
      lastScroll: 0,
      lastLoadedTime: 0,
      processingTableView: false,
      deltaScroll: 10,
      doneLoading: false,
      cahcedCols: {},
      // lastTimeWindowUpdated: false,
      silent: false,
      tableData: [],
      autoCols: null,
      query: {},
      dWindowTop: 0,
      difTop: 0,
      transportRow: null,
      lastEditRow: null,
      coolDown: 0,
      // difBottom:0,
      dWindowBottom: null,
      // viewIndexer: {},
      deltaStep: 0,
      optimalHeight: "10vh",
      loading: false,
      initloading: true,
      pagingCounter: 0,
      oldTOpGap: 0,
      editingCoord: {col: null, row: null}
    };
  },

  watch: {
    topOffset(v, vo) {
      this.$nextTick(() => {
        if (v != vo) this.calcHeight();
      });
    },
    async "$route.path"(to, from) {
      if (!this.wakeUpPath) return;
      _log_("route[TABLE QUERY]", this.$route);
      if (!to) return;
      if (to == from) return;

      if (to.indexOf(this.wakeUpPath) >= 0) await this.loadInfinite(true, true);
    },
    rQuery: {
      handler: async function (newValue, oldVal) {
        this.justSelectedAll = false
        if (!this.apiProcessor) return;
        const comingQuery = this.safeSet(newValue);
        if (newValue && !this.isQueryNew(comingQuery)) return;

        this.resetTableState();

        if (!newValue) {
          this.tableData = [];
          return;
        }

        // if (!_.isEqual(this.query, newValue)) {
        this.tableData = [];
        _log_("comingQuery REG SQuery.", this.query);
        this.query = comingQuery; // this.safeSet(newValue);
        await this.reload();

        // await this.loadInfinite();
        // }
      },
      deep: true
    },
    editingCoord: {
      handler: function (newValue) {
        // _log_("vcoord,", newValue);
        if (newValue.col !== null && newValue.row !== null)
          this.$refs.stable.clearSort();
      },
      deep: true
    },
    value: {
      handler: function (newValue) {
        _log_("v-model,newValue", newValue, this.tableData);
        let thereAreChanges = !this.tableData?.length && newValue?.length
        if (!this.silent) {
          let newValueInexed = {}, changeFound = false
          newValue.forEach(c => newValueInexed[c[this.rowKeyField]] = c)
          // _log_("v-model,", this.rowKeyField,newValueInexed);
          let this_tableData = JSON.parse(JSON.stringify(this.tableData))

          this_tableData = this_tableData.map(r => {

            if (!newValueInexed[r[this.rowKeyField]]) return r
            const nr = {...r, ...(newValueInexed[r[this.rowKeyField]] || {})}
            changeFound = JSON.stringify(r) != JSON.stringify(nr)
            if (changeFound) thereAreChanges = true
            return changeFound ? nr : r
          })
          if (thereAreChanges) {
            this.tableData = this_tableData?.length ? this_tableData : newValue;
            _log_("v-model,changeFound", this.tableData);
          }
        }
      },
      deep: true
    },
    tableData: {
      handler: function (newValue) {

        const vm = this;
        let element = null,
            addLine = false;
        if (this.tableData?.length) {
          if (!this.colDefinitions.length) {
            this.autoCols = []
            for (const tableDatumKey in this.tableData[0]) if (!['idx',
              'height'].includes(tableDatumKey)) this.autoCols.push({
              prop: tableDatumKey,
              label: tableDatumKey.replaceAll('_', ' ')
            })
            _log_("intableData handler,", this.autoCols);
          }
        }
        if (newValue) this.$emit("input", newValue);
        if (!this.addEmptyLine || this.editDisabled) return;
        //fix missing idxs
        let idx = 0;
        _log_("intableData handler, start")
        if (this.tableData?.length) {
          // if (!this.colDefinitions.length) {
          //   this.autoCols = []
          //   for (const tableDatumKey in this.tableData[0]) this.autoCols.push({
          //     prop: tableDatumKey,
          //     label: tableDatumKey
          //   })
          //   _log_("intableData handler,", this.autoCols);
          // }
          this.tableData.forEach(element => {
            if (!element.idx) this.$set(element, "idx", idx);
            ++idx;
          });
        }
      },
      deep: true
    },
    // editDisabled(is, was) {
    //   // _log_("KILLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLL me");
    //   if (!this.addEmptyLine) return;
    //   const vm = this;
    //
    //   if (
    //     is != was &&
    //     !is &&
    //     !_.find(this.tableData, function(tr) {
    //       return !tr.transactionId;
    //     })
    //   ) {
    //     var nullO = {};
    //     vm.colDefinitionsProcessed.forEach(col => {
    //       nullO[col.prop] = "";
    //     });
    //     // _log_(">>>>A1>>", nullO);
    //     this.appendTrackedData([nullO]);
    //     // this.tableData.push(nullO);
    //   }
    // }
  },
  computed: {
    apiProcessor() {
      return this.modxProcessor || this.laraProcessor
    },
    controlQueryParams: {
      set(v) {
        if (!v) return
        let sortO = {}
        if (v.sort) sortO[(this.routeQueryPrefix || this.apiProcessor) + '_sort'] = v.sort
        if (v.dir) sortO[(this.routeQueryPrefix || this.apiProcessor) + '_dir'] = v.dir
        this.routeGo({query: sortO})
      },
      get() {
        let sortO = {}
        if (this.$route.query[(this.routeQueryPrefix || this.apiProcessor) + '_sort']) sortO.sort = this.$route.query[(this.routeQueryPrefix || this.apiProcessor) + '_sort']
        if (this.$route.query[(this.routeQueryPrefix || this.apiProcessor) + '_dir']) sortO.dir = this.$route.query[(this.routeQueryPrefix || this.apiProcessor) + '_dir']
        return sortO
      }
    },
    lazyLoadEnabled() {
      return this.lazyLoader //&& !this.justSelectedAll;
    },
    ...mapGetters({
      getList: "tags/getList",
      getStore: "helpers/getStore",
    }),
    colDefinitionsProcessed() {
      const vm = this;
      if (!this.colDefinitions || !this.colDefinitions.length) {
        if (this.autoCols) return this.autoCols
        return [];
      }
      return this.colDefinitions.filter(function (col) {
        if (col.onlyEditMode && vm.editDisabled) return false;
        return true;
      });
    },
    dataWindow() {
      _log_("...dataWindow...1", this.tableData);
      let o = [];
      // if (!vm.processingDataView) return;
      if (!this.tableData) return;
      if (!this.tableData.length) return;
      if (this.simpleLazyLoader || !this.lazyLoadEnabled) {
        return this.tableData;
      }
      // _log_("...dataWindow...1", this.tableData);
      const domEl = this.$el,
          vm = this;
      if (this.allwaysEdit) return this.tableData;
      const bottom_idx = vm.topIdx + vm.pagging;
      let lastGap = 0
      o = this.tableData.filter(function (rec) {
        const elmv = vm.$refs[rec.idx + "_cell_0"]
            ? vm.$refs[rec.idx + "_cell_0"][0]
            : null;
        if (elmv && elmv.parentNode && elmv.parentNode.parentNode) {
          const botmelm =
                  elmv.parentNode.parentNode.offsetTop +
                  elmv.parentNode.parentNode.offsetHeight,
              topelm = elmv.parentNode.parentNode.offsetTop,
              elmh = elmv.parentNode.parentNode.getBoundingClientRect().height;

          if (!vm.hiddenRows[rec.idx] && rec.idx < vm.topIdx) {
            lastGap = vm.hiddenRows[rec.idx] = elmh;
            vm.deltaStep = vm.gap.top;
            // _log_("...hide..." + vm.gap.top);
            vm.gap.top += vm.hiddenRows[rec.idx]; // botmelm; //elmv.parentNode.parentNode.getBoundingClientRect().bottom;
            vm.deltaStep = Math.abs(vm.deltaStep - vm.gap.top);
          }
        }

        return rec.idx >= vm.topIdx && rec.idx < bottom_idx;
      });
      let topgap = vm.gap.top - lastGap,
          botompgap = 100;

      let fo = [];
      // _log_("...added..." + vm.topIdx, o, bottom_idx);
      if (this.tableData.length && topgap) {
        fo = [{idx: "gaptop", hidden: true, height: topgap},
          ...o];

        // _log_("...added..." + topgap, fo);
      } else fo = o;
      // if (!o || o.length < (vm.pagging-1)) vm.doneLoading = true;
      // _log_("...added...",fo);gaptop gapbottom
      if (botompgap && !vm.addEmptyLine && !vm.doneLoading)
        fo.push({idx: "gapbottom", hidden: true, height: 10});

      this.$nextTick(() => {
        this.$refs.stable.doLayout()
        const x = domEl.getElementsByClassName("el-table__body-wrapper")[0];

        // _log_("...added..." + vm.processingTableView);
        // var x = domEl.getElementsByClassName("el-table__body-wrapper")[0];
        const the_gap_is = vm.$refs["gaptop_cell_0"],
            the_gap = the_gap_is ? the_gap_is[0] : null;
        if (the_gap && the_gap.parentNode && the_gap.parentNode.parentNode) {
          const goh = the_gap.parentNode.parentNode.getBoundingClientRect()
              .height;
          _log_("...croll.scrollTop.." + vm.lastScroll, goh, the_gap.parentNode, the_gap);
          x.scrollTop = goh;
        }
        vm.lastScroll = x.scrollTop;
        vm.processingTableView = false;
      });
      return fo;
    }
  },
  async mounted() {

    const vm = this;

    if (this.autoClearStore)
      this.clearStore(this.selectStorage)
    // this.lastQuery = JSON.stringify(this.rQuery);
    this.query = this.safeSet(this.rQuery);
    this.isQueryNew(this.query); //first time
    this.colDefinitionsProcessed.forEach(col => {
      vm.cahcedCols[col.prop] = col;
    });
    this.resetTableState();

    if (this.addEmptyLine && this.lazyLoadEnabled)
      console.error(
          "If you use add new line and lazy loading the second will not work"
      );
    if (this.lazyLoadEnabled)
      this.$nextTick(() => {
        if (!vm.$refs.stable) return;
        vm.SELECTWRAP_DOM = vm.$refs.stable.$el.querySelector(
            ".el-table__body-wrapper"
        );
        vm.SELECTWRAP_DOM_BODY = vm.$refs.stable.$el.querySelector(
            ".el-table__body"
        );
        vm.SELECTWRAP_DOM.addEventListener("scroll", e => {
          this.$refs["stable"].$emit("table-scroll", e);
        });
      });

    await this.loadInfinite();
    this.initloading = false;
    this.calcHeight();
    vm.loading = false;

    // this.lazyLoadScroll();
  },

  methods: {
    ...mapMutations({
      toggleSelection: "helpers/toggleSelection",
      clearStore: "helpers/clearStore",
      setStore: "helpers/setStore",
    }),
    isSelectedInStorage(row) {
      if (!this.$store.state.helpers.general_store[this.selectStorage]) return false
      this.$set(row, '_selected', !!this.$store.state.helpers.general_store[this.selectStorage][row[this.rowKeyField]])
      return !!this.$store.state.helpers.general_store[this.selectStorage][row[this.rowKeyField]]
    },
    async selectInStorage(row) {
      // _log_('selectInStorage...', row)
      const vm = this
      let sO = {context: this.selectStorage}
      if (!row) {
        if (this.cellSelectionWithObjects) {
          this.initloading = true;
          let data = await this.getServData({
            ...this.query,
            start: 0
          }, true);

          if (data && data.results) {
            if (data.results.length < data.total) {
              this.$message({
                message: 'too many things  to handle (over ' + data.total + ' items), try to apply some filters',
                duration: 30000,
                showClose: true,
                type: "warning"
              })
              this.initloading = false;
              return
            }
            data.results.forEach(rec => {
              sO._sk = rec[vm.rowKeyField]
              sO.data = rec
              vm.toggleSelection(sO)
              //  vm.$store.commit('resource/toggleSelection', sO)
            })
          }
          this.tableData.forEach(row => this.$set(row, '_selected', !!this.$store.state.helpers.general_store[this.selectStorage][row[this.rowKeyField]]))
          this.$emit("select", Object.values(this.$store.state.helpers.general_store[this.selectStorage]));

          this.justSelectedAll = !this.justSelectedAll
          this.initloading = false;
          // ++this.clock
          return
        } else {
          sO._sk = 'query'
          sO.data = {queryParams: {...this.rQuery}, controller: this.apiProcessor}

          vm.toggleSelection(sO)
          _log_('this.$store.state.helpers.general_store[this.selectStorage]', this.selectStorage, this.$store.state.helpers.general_store)
          this.justSelectedAll = !this.justSelectedAll
          return
        }
      }

      //one selection
      sO._sk = row[this.rowKeyField]
      sO.data = row

      vm.toggleSelection(sO)

      // this.$store.commit('resource/toggleSelection', sO)
      // if (
      //     !this.$store.state.resource.selections[this.selectStorage]
      // )
      if (
          !this.getStore(this.selectStorage)
      )
        this.$emit("select", null);
      else
        this.$emit("select", Object.values(this.$store.state.helpers.general_store[this.selectStorage]));

      this.$set(row, '_selected', !!this.$store.state.helpers.general_store[this.selectStorage][row[this.rowKeyField]])

      //   this.$emit("select", Object.values(this.$store.state.resource.selections[this.selectStorage]));
      // this.$set(row, '_selected', !!this.$store.state.resource.selections[this.selectStorage][row[this.rowKeyField]])

    },
    editRow(scope) {
      this.editRowData = scope.row;
      this.editDialog = true;
    }
    ,
    handleCellChange($event, colprops, scope, dontMove) {
      _log_("yelooo selectedOption", scope.column.property);
      if (colprops.onChange) colprops.onChange($event, scope.row);
      if (!dontMove) this.forwardEditCell(colprops, scope.row);

      this.$emit("cell-change", {
        prop: scope.column.property,
        row: scope.row
      });
    }
    ,
    moveRow(ev, item) {
      _log_("moveRaw realAll", ev, item);
      this.transportRow = item;
    }
    ,
    dropRow(ev, dropItem) {
      _log_('dropppp', ev, dropItem)
      if (this.transportRow && this.sortingProp) {
        const sprop = this.sortingProp === true ? "idx" : this.sortingProp;
        const draged_seq = this.transportRow[sprop], droped_seq = dropItem[sprop]
        dropItem[sprop] = draged_seq
        this.transportRow[sprop] = droped_seq
        this.$emit("cell-change", {
          prop: sprop,
          row: dropItem
        });
        this.$emit("cell-change", {
          prop: sprop,
          row: this.transportRow
        });
        // let sq={}
        // sq[sprop]=item[sprop]
        // const pos=  this.findInArray(this.tableData,sq,true)
        var dataSorted = [],
            // idx = 0,
            offset = 0,
            avoid = this.transportRow[this.rowKeyField] + "";
        const mappedSorts = this.tableData.map(e => e[sprop]);
        for (let idx = 0; idx < this.tableData.length; idx++) {
          let el = this.tableData[idx];
          if (dropItem[this.rowKeyField] == el[this.rowKeyField]) {
            this.transportRow[sprop] = mappedSorts[idx];
            dataSorted.push(this.transportRow);

            // ++idx;
            el[sprop] = mappedSorts[idx + 1];
            offset = 1;
            dataSorted.push(el);
            // ++idx;
          } else if (avoid != el[this.rowKeyField]) {
            el[sprop] = mappedSorts[idx + offset];
            dataSorted.push(el);
          } else offset = 0;
        }

        // this.tableData.forEach((el) => {
        //   // _log_("in realAll", el.id, el.idx);
        //   if (dropItem[sprop] == el[sprop] && !skipNext) {
        //     this.transportRow[sprop] = mappedSorts[idx];
        //     dataSorted.push(this.transportRow);
        //     ++idx;
        //     skipNext = true;
        //     el[sprop] = mappedSorts[idx];
        //     dataSorted.push(el);
        //     ++idx;
        //   } else {
        //     if (avoid != el[this.rowKeyField] && !skipNext) {
        //       el[sprop] = mappedSorts[idx];
        //       dataSorted.push(el);
        //       ++idx;
        //     }
        //     if (skipNext) {
        //       skipNext = false;
        //     }
        //   }
        // });
        this.tableData = dataSorted;
        this.$emit(
            "changeOrder",
            dataSorted.map(e => {
              let o = {};
              o[this.rowKeyField] = e[this.rowKeyField];
              o[sprop] = e[sprop];
              return o;
            })
        );
        this.$emit("input", this.tableData);

      }
      this.transportRow = null;
    }
    ,
    emitInput: _.debounce(
        function (e) {
          // _log_("cell input", dataSorted);
          this.$emit("cell-input", e);
        },
        650,
        {maxWait: 1200}
    ),
    async realAll(selectionRows) {
      const vm = this;
      _log_("nextTick 00 realAll", selectionRows);
      if (this.justSelectedAll) {
        if (!selectionRows.length) this.justSelectedAll = false;
        return;
      }

      await this.reloadAll();
      this.$nextTick(function () {
        this.justSelectedAll = true;

        // this.$refs.stable.clearSelection();
        vm.$refs.stable.toggleAllSelection();
        // this.$nextTick(function () {
        //   vm.$refs.stable.toggleAllSelection();
        // });
      });
    }
    ,
    async handleSelectionChange(val) {
      // if (this.justSelectedAll) {
      //   if (val && val.length) this.justSelectedAll = false;
      //   return;
      // }
      // if (!this.countSelected && val.length > 1) {
      //   await this.reloadAll();
      //   this.$refs.stable.clearSelection();
      //   this.$refs.stable.toggleAllSelection();
      // }
      // this.countSelected = val.length;
      // _log_("handleSelectionChange select ", row, val);
      // this.$set(row, '_selected', row._selected ? false : true)

      this.$emit("select", val);
      // this.multipleSelection = val;
    }
    ,
    handleCellInput(scope) {
      // _log_("what? handleCellInput W ,x ", scope);
      this.$emit("cell-input", {prop: scope.column.property, row: scope.row});
      // this.goAddNewLine();
    }
    ,
    resetTableState() {
      if (this.autoClearStore)
        this.clearStore(this.selectStorage)
      this.dWindowTop = null;
      this.lastScroll = 0;
      this.dWindowBottom = null;
      this.lastIdxClicked = null;

      this.doneLoading = false;
      this.lastLoadedTime = 0;
      this.hiddenRows = {};
      this.gap = {top: 0, bottom: 0};
      this.tableData = [];

      this.dWindowTop = null;
      this.gap.top = 0;
      this.topIdx = 0;
      this.gap.bottom = 0;
      this.dWindowBottom = null;

      this.pagingCounter = 0;
    }
    ,
    async lazyLoadScroll(e) {
      const vm = this;
      _log_('lazyLoadScroll', e)
      let d = new Date();
      if (vm.loading) return;
      this.editingCoord = {col: null, row: null};
      // if (what.going === this.$waypointMap.GOING_OUT) return;
      let x = vm.SELECTWRAP_DOM,
          nowScrolledAt = x.scrollTop,
          xin = vm.SELECTWRAP_DOM_BODY,
          tableHeight = x.clientHeight; // x.getBoundingClientRect().height;
      // if (d.getTime() - vm.lastLoadedTime < 600) return;
      // if (Math.abs(vm.lastScroll - nowScrolledAt) < 10) return;
      // if (Math.abs(vm.lastScroll - nowScrolledAt) < vm.deltaStep) return;
      // _log_("what? now W ,x ", nowScrolledAt, vm.lastScroll);

      const the_gap_is = vm.$refs["gaptop_cell_0"],
          the_gap = the_gap_is ? the_gap_is[0] : null;
      // _log_("what? now W ,x ", vm.hiddenRows, the_gap_is);
      // _log_("what? now W ,xgohgoh ", vm.oldTOpGap, the_gap_is);
      if (the_gap && the_gap.parentNode && the_gap.parentNode.parentNode) {
        const goh = the_gap.parentNode.parentNode.getBoundingClientRect()
            .height;

        if (vm.oldTOpGap != goh) {
          // _log_("what? now W ,xgohgoh XXXXX", vm.oldTOpGap, goh);
          vm.oldTOpGap = goh;

          return;
        }
      }
      if (vm.processingTableView) return;
      if (!vm.dataWindow) return;
      vm.processingTableView = true;
      const goingUp = vm.lastScroll > nowScrolledAt,
          goingDown = vm.lastScroll < nowScrolledAt,
          stopped = vm.lastScroll === nowScrolledAt; // - nowScrolledAt > vm.outerRowHeight;

      const jump_counter = vm.deltaStep
          ? Math.floor(Math.abs(vm.lastScroll - nowScrolledAt) / vm.deltaStep)
          : 1;
      _log_('vm.hiddenRows deltaStep', vm.lastScroll - nowScrolledAt, jump_counter, Object.keys(vm.hiddenRows).length, vm.tableData.length)
      if (!vm.simpleLazyLoader) {
        let jump_step = jump_counter || 1;
        // if (jump_counter > 17) jump_step = 17;
        // else if (jump_counter > 1 && jump_counter < 18) jump_step = jump_counter;
        // _log_("what? now W ,jump ", jump_counter);
        if (goingDown) vm.topIdx += jump_step;
        if (goingUp) vm.topIdx -= jump_step;

        vm.dataWindow.forEach(row => {
          if (row.idx != "gaptop" && row.idx != "gapbottom") {
            const lelmH = vm.hiddenRows[row.idx];
            if (lelmH && row.idx > vm.topIdx) {
              vm.deltaStep = vm.gap.top;
              vm.gap.top -= lelmH;
              vm.deltaStep = Math.abs(vm.deltaStep - vm.gap.top);
              delete vm.hiddenRows[row.idx];

            }
          }
        });
      }
      vm.lastLoadedTime = d.getTime();
      vm.processingTableView = false;

      const agap = vm.$refs["gaptop_cell_0"],//gap-row
          htmla = agap ? agap[0] : null, gapRows = document.getElementsByClassName("gap-row"),
          gapRow = gapRows ? gapRows[0] : null, gapRowY = gapRow ? gapRow.getBoundingClientRect() : 0

      if (htmla) {
        // var bottomGapMeta = htmlb.parentNode.parentNode.getBoundingClientRect(),
        var offsetFromTOp = htmla.parentNode.parentNode.offsetTop;
        // _log_("ONS-TOP--LOAD?++", htmla.parentNode.parentNode.offsetTop);
      }
      const bgap = vm.$refs["gapbottom_cell_0"],
          htmlb = bgap ? bgap[0] : null;

      if (htmlb) {
        // var bottomGapMeta = htmlb.parentNode.parentNode.getBoundingClientRect(),
        let offsetFromTOp = htmlb.parentNode.parentNode.offsetTop;
        // _log_(
        //     "what? now W ,jump ",nowScrolledAt , tableHeight,offsetFromTOp,nowScrolledAt + tableHeight)
        if (nowScrolledAt + tableHeight > offsetFromTOp) {
          // _log_("what? now ONS---LOAD?++",nowScrolledAt + tableHeight);
          await vm.loadInfinite(true);
        }
      }
      // vm.lastScroll = nowScrolledAt;
    }
    ,
    isQueryNew(newQ) {
      let isEqual = true;

      if (this.lastQuery) {
        // _log_("go check.newQ.SQuery..OLD..", this.lastQuery);
        // _log_("go check.newQ.SQuery..NEW..", JSON.stringify(newQ));
        const oldQuery = JSON.parse(this.lastQuery);

        for (const key in oldQuery) {
          if (oldQuery.hasOwnProperty(key)) {
            const val = JSON.stringify(oldQuery[key]),
                nval = JSON.stringify(newQ[key]);
            if ((!val && nval) || (val && !nval) || val != nval) {
              isEqual = false;
              break;
            }
          }
        }
        if (isEqual && oldQuery)
          for (const key in newQ) {
            if (newQ.hasOwnProperty(key)) {
              const val = JSON.stringify(oldQuery[key]),
                  nval = JSON.stringify(newQ[key]);
              if ((!val && nval) || (val && !nval) || val != nval) {
                isEqual = false;
                break;
              }
            }
          }
      }
      _log_("go check.newQ.SQuery IS.", isEqual);
      this.lastQuery = JSON.stringify(newQ);
      return !isEqual;
    }
    ,
    safeSet(obj) {
      if (!obj) return null;
      var newobj = {};
      for (const key in obj) {
        if (
            obj.hasOwnProperty(key) &&
            obj[key] !== undefined &&
            obj[key] !== null
        ) {
          this.$set(newobj, key, obj[key]);
          // newobj[key] = obj[key];
        }
      }
      return newobj;
    }
    ,
    notifyForClickMobile(row, column, cell, event) {
      _log_("aaaaas");
      this.editingCoord = this.getCoordinates(
          {row: row, column: column},
          this.colDefinitionsProcessed
      );
      const coldef = this.findInArray(this.colDefinitions, {
        prop: column.prop
      });
      if (coldef.enableClickCell) {
        coldef.isClickable = coldef.enableClickCell(row);
      }
      if (coldef.isClickable !== false) {
        if (coldef.onClick) coldef.onClick.apply(this, [row,
          event]);
        this.$emit("cell-clicked", {
          row: row,
          column: column,
          cell: cell,
          event: event
        });
      }
      // this.$emit("cell-clicked", {
      //   row: row,
      //   column: column,
      //   cell: cell,
      //   event: event
      // });
    }
    ,
    notifyForClick(row, column, cell, event, rowScope) {
      _log_("notifyForClick...");
      if (this.mobileMode) return;
      this.lastIdxClicked = row.idx;

      this.editingCoord = this.getCoordinates(
          {row: row, column: column},
          this.colDefinitionsProcessed
      );
      // _log_(
      //     "span.SORT..se..",
      //     this.editingCoord,
      //     row,
      //     column,
      //     cell,
      //     event
      // );
      const coldef = this.findInArray(this.colDefinitions, {
        prop: column.property
      });
      if (!coldef) {
        console.error(
            "Cant click..., row, column, cell, event",
            row,
            column,
            cell,
            event
        );
        return;
      }
      if (coldef.enableClickCell) {
        coldef.isClickable = coldef.enableClickCell(row);
      }
      if (coldef.isClickable !== false) {
        if (coldef.onClick) coldef.onClick.apply(this, [row,
          event]);
        this.$emit("cell-clicked", {
          row: row,
          column: column,
          cell: cell,
          event: event
        });
      }
    }
    ,
// forceNotifyForClick(row, column, cell, event, rowScope) {
//   this.$emit("cell-clicked", {
//     row: row,
//     column: column,
//     cell: cell,
//     event: event
//   });
// },
    customSort(a, b) {
      return 0;
    }
    ,
    ensureInView(container, element) {
      //Determine container top and bottom
      let cTop = container.scrollTop;
      let cBottom = cTop + container.clientHeight;

      //Determine element top and bottom
      let eTop = element.offsetTop;
      let eBottom = eTop + element.clientHeight;

      //Check if out of view
      if (eTop < cTop) {
        container.scrollTop -= cTop - eTop;
      } else if (eBottom > cBottom) {
        container.scrollTop += eBottom - cBottom;
      }
    }
    ,

    checkInView(container, element, partial) {
      //Get container properties
      let cTop = container.scrollTop;
      let cBottom = cTop + container.clientHeight;

      //Get element properties
      let eTop = element.offsetTop;
      let eBottom = eTop + element.clientHeight;

      //Check if in view
      let isTotal = eTop >= cTop && eBottom <= cBottom;
      let isPartial =
          partial &&
          ((eTop < cTop && eBottom > cTop) ||
              (eBottom > cBottom && eTop < cBottom));

      //Return outcome
      return isTotal; //|| isPartial;
    }
    ,

    spanHiddenRows({row, column, rowIndex, columnIndex}) {
      if (
          row &&
          columnIndex == 1 &&
          ((this.dWindowTop > 2 && rowIndex == 0) ||
              rowIndex == this.dWindowBottom + 4)
      ) {
        //} && row.idx <= this.dWindowTop - 5) {
        _log_("span...row..", rowIndex, columnIndex, this.dWindowTop);
        return {
          rowspan: this.dWindowTop - 4,
          colspan: this.colDefinitions.length - 1
        };
      } else
        return {
          rowspan: 1,
          colspan: 1
        };
    }
    ,

    canBeEdit(colprops, scope) {
      if (!colprops) return false
      const srow = scope.row ? scope.row : scope;
      if (!srow) return false;
      if (srow.hide) return false;
      // _log_("go canBeEdit...",colprops.prop, colprops, srow);
      if (!this.editDisabled && colprops.editWhen) return colprops.editWhen(srow)
      return (
          colprops.editable &&
          !this.editDisabled &&
          (colprops.editWhen == undefined || colprops.editWhen(srow))
      );
    }
    ,
    isEditState(colprops, scope) {
      // _log_("go ssssCLRs...", colprops, this.editingCoord);
      const onEdit = (
          this.canBeEdit(colprops, scope) &&
          (this.allwaysEdit ||
              this.isFocushed(
                  this.editingCoord,
                  scope,
                  this.colDefinitionsProcessed
              ))
      );
      if (onEdit)
        this.lastEditRow = scope
      return onEdit
    }
    ,
    preCellClassFactory(scope) {

      if (scope.row.idx == "gapbottom") return "gap-cell";
      const workingCol = this.cahcedCols[scope.column.property];
      if (scope.column.property == 'ppid')
        _log_("preCellClassFactory...", scope.column.property);
      const editable = this.canBeEdit(workingCol, scope) ? 'editable ' : ''
      // const colDef
      //  _log_("CLASSSSS..." ,editable);
      if (workingCol && (workingCol.clickable || workingCol.isClickable)) {
        // _log_("CLASSSSS...", scope);
        if (!workingCol.enableClickCell) return "clickable";
        else if (workingCol.enableClickCell(scope.row))
          return editable + (
              (workingCol.buttonType ? workingCol.buttonType : "") + " clickable"
          ); //(colprops.disableClick&&colprops.disableClick(scope.row)?colprops.buttonType+' ':'')+
      }
      if (this.cellClassFactory) return editable + this.cellClassFactory(scope);
      return editable;
    }
    ,
    forwardEditCell(coldef, rowScope) {
      if (coldef.forwardEditOnChange === false) return false;
      let coordinates = this.editingCoord;
      _log_(
          "NAV.OOO..ln forwardEditCell",
          coordinates.col,
          this.columnEditableCount(this.colDefinitionsProcessed, rowScope)
      );
      if (
          this.columnEditableCount(this.colDefinitionsProcessed, rowScope) - 1 >
          coordinates.col
      )
        ++coordinates.col;
      else {
        coordinates.col = 0;
        ++coordinates.row;
      }
      this.$emit("nav-right", coordinates);
    }
    ,
    selectionClass(e) {
      // _log_(
      //   "go ssssCLRs..." + this.rowKeyField,
      //   this.lastIdxClicked,
      //   e.row.idx
      // );
      if (e.row.hide) return null;
      let extraClasses = 'clickable ' + (this.mobileMode ? "responsive-row" : "");

      if (e.row.idx == "gapbottom") return "gap-row";
      if (
          this.selectionId &&
          e.row &&
          e.row[this.rowKeyField] == this.selectionId
      )
        extraClasses = this.selectedClass;
      else if (e.row.idx == this.lastIdxClicked)
        extraClasses += this.selectedClass;
      if (!this.rowKeyField) return "";
      //
      if (e.row && !e.row[this.rowKeyField]) extraClasses = this.newClass;

      if (this.rowClassFactory) extraClasses += " " + (this.rowClassFactory(e) || '');
      if (e.row.isDeleted) extraClasses += " isDeleted";
      return extraClasses;
    }
    ,
    async appendRecord(
        defaultValues = {},
        makeRecordFromDefault = false,
        idField = "id"
    ) {
      this.$refs.stable.doLayout()
      _log_("go test..", defaultValues);
      // if (this.lastEditRow) {
      //   this.handleCellInput(this.lastEditRow)
      //   this.lastEditRow = null
      // }
      let vm = this,
          firstElement = this.tableData.length ? this.tableData[0] : null;
      //check if new line exists
      if (
          !firstElement ||
          (firstElement &&
              firstElement[idField] &&
              firstElement[idField] != "" &&
              firstElement[idField] != 0)
      ) {
        //  this.tableData = []
        let newLine = {},
            newTableData = [];

        this.colDefinitions.forEach(col => {
          newLine[col.prop] =
              defaultValues && defaultValues[col.prop]
                  ? defaultValues[col.prop]
                  : null;
        });
        for (const key in defaultValues) {
          if (defaultValues.hasOwnProperty(key)) {
            newLine[key] = defaultValues[key];
          }
        }
        // this.gap = {top: 0, bottom: 0}
        this.pagingCounter = 0
        await this.reload();
        this.appendTrackedData(newLine, true);
        // newTableData.push(newLine);
        // this.tableData.forEach(element => {
        //   newTableData.push(element);
        // });

        // this.tableData = newTableData;
        // ++this.moundKey;
        this.$nextTick(function () {
          vm.editingCoord = {col: 0, row: 0};
        });
        // _log_("test..", newLine, this.tableData);
      }
    }
    ,
    isTouchDevice() {
      return false;
    }
    ,
    async getServData(params, forceAll, forceLimit) {
      params = params ? params : {};
      params.limit = this.lazyLoadEnabled && !forceAll ? this.pagging : this.maxRows;
      if (forceLimit) params.limit = forceLimit
      // if (!this.simpleLazyLoader) {
      //   params.start = this.topIdx ? this.topIdx - 1 : 0;
      // } else {
      //   params.start = this.pagingCounter * this.pagging;
      // }
      params.start = this.pagingCounter * this.pagging;
      // _log_("checking..getServData ", params, this.query, this.controlQueryParams);
      if (this.apiProcessor) {
        const {data} = this.modxProcessor ? await api.fetchProcessor(this.apiProcessor, {
              ...this.query,
              ...this.controlQueryParams,
              ...params,

            }) :
            await apiGetCall(this.apiProcessor, {
              ...this.query,
              ...this.controlQueryParams,
              ...params,

            });
        this.$emit('data-loaded', data)
        return data;
      } else if (typeof this.endPoint === "function") {
        const data = await this.endPoint(params);
        if (data.data) return {results: data.data};
        else return {results: data};
      } else return {data: {results: []}};
    },
    async reloadState(designateDeleted) {
      this.initloading = true;
      const data = await this.getServData({
        ...this.query,
        limit: this.lazyLoadEnabled ? this.pagging : 0,
        start: this.topIdx ? this.topIdx - 1 : 0
      });
      _log_("test..remove ", this.query, data);
      const vm = this;
      data.results.forEach(d => {
        vm.updateRow(d);
      });
      if (designateDeleted) {
        this.dataWindow.forEach(element => {
          var q = {};

          q[vm.rowKeyField] = element[vm.rowKeyField];

          if (!vm.findInArray(data.results, q)) {
            _log_("test..remove ii");
            q.isDeleted = true;
            vm.updateRow(q);
          }
        });
      }
      this.initloading = false;
    }
    ,
    hasEmptyLine() {
      if (!this.tableData) return false
      for (const item of this.tableData) {
        if (
            item.idx != "gaptop" &&
            item.idx != "gapbottom" &&
            !item[this.rowKeyField]
        ) {
          _log_("test.." + item.idx, item);
          return true;
        }
      }
      return false;
    }
    ,
    async reloadAll() {
      this.lastScroll = 0;
      this.lastIdxClicked = null;
      this.lastLoadedTime = 0;
      this.hiddenRows = {};
      this.tableData = [];
      this.doneLoading = false;
      this.dWindowTop = null;
      this.gap.top = 0;
      this.topIdx = 0;
      this.gap.bottom = 0;
      this.dWindowBottom = null;

      this.pagingCounter = 0;
      // _log_("test..", e);
      this.editingCoord = {col: null, row: null};

      let data = await this.getServData({
        ...this.query,

        limit: 0,
        start: 0
      }, true);
      // _log_("check.go..more..0000.." + this.pagging, data);
      if (!data.results || data.results.length < this.pagging)
        this.doneLoading = true;
      else this.doneLoading = false;
      this.appendTrackedData(data.results);
      if (data) this.$emit("dataFetched", data);
    }
    ,
    updateRow(rowSelector, updateData, orAppend) {
      // _log_("addd..befor", this.tableData);
      var whatSelect = {};
      if (!updateData) {
        updateData = rowSelector;
        whatSelect[this.rowKeyField] = updateData[this.rowKeyField];
      } else whatSelect = rowSelector;

      var append = false;
      if (orAppend) {
        append = !this.findInArray(this.tableData, whatSelect);
      }
      if (append) this.appendTrackedData(updateData);
      else {
        if (this.tableData && this.tableData.length)
          this.tableData = this.updateArray(
              this.tableData,
              whatSelect,
              updateData
          );
      }
      this.goAddNewLine(true);
      // this.$nextTick(() => {
      //         this.goAddNewLine();
      //       });
      // _log_("addd..aft", this.tableData, whatSelect, updateData);
    }
    ,
    async reloadRowOrAppend(data, use_idx) {
      _log_(
          "addd..reloadRowOrAppend...",
          this.rowKeyField,
          data[this.rowKeyField],
          data
      );
      if (!data[this.rowKeyField]) return false;
      var success = await this.reloadRow(data[this.rowKeyField]);
      if (!success) this.appendTrackedData([data]);
    }
    ,
    async n_reloadRow(rowId, use_idx) {
      this.initloading = true;
      var q = {};
      _log_("test..reloadRowOrAppend...-------------", rowId);
      q[this.rowKeyField] = rowId;
      var fetchQ = {...this.query, id: rowId};
      // _log_("test..reloa...", rowdata);
      var data = await this.getServData(fetchQ);
      if (data.results) this.updateRow(q, data.results[0]);
      this.initloading = false;
      return true;
    }
    ,
    async reloadRow(rowId, use_idx) {
      this.initloading = true;
      let q = {};
      _log_(
          "test..reloadRowOrAppend...-------------" + this.rowKeyField,
          rowId
      );
      q[this.rowKeyField] = rowId;
      let rowdata = this.findInArray(this.dataWindow, q);
      if (!rowdata) {
        this.initloading = false;
        return false;
      }
      let fetchQ =
          use_idx || !rowdata.id
              ? {
                ...this.query,
                limit: 1,
                start: rowdata.idx - 1
              }
              : {...this.query, id: rowdata.id};
      _log_("test..reloa...", rowdata, fetchQ);
      let data = await this.getServData(fetchQ);
      if (data.results) this.updateRow(q, data.results[0]);
      else if (data.object) this.updateRow(q, data.object);
      this.initloading = false;
      return true;
    }
    ,
    async reload(e) {
      this.tableData = [];
      if (this.oneLoad !== false) {
        this.tableData = this.tableData.sort((a, b) => ((a[e.prop] || 0) - (b[e.prop] || 0)) * (e.order == "ascending" ? 1 : -1))
        return
      }
      _log_("test.R.", this.tableData);
      this.lastScroll = 0;
      this.lastIdxClicked = null;
      this.lastLoadedTime = 0;
      this.hiddenRows = {};

      this.doneLoading = false;
      this.dWindowTop = null;
      this.gap.top = 0;
      this.topIdx = 0;

      this.gap.bottom = 0;
      this.dWindowBottom = null;

      this.pagingCounter = 0;
      _log_("test..", e);
      this.editingCoord = {col: null, row: null};
      this.tableData = null
      _log_("comingQuery REG 0SQuery.", this.query);
      if (e) {

        this.controlQueryParams = e.order ? {
          sort: e.prop,
          dir: e.order == "ascending" ? "ASC" : "DESC"
        } : {}
        // this.query = {
        //   ...this.query,
        //   ...this.controlQueryParams
        // };
      }
      // await this.loadInfinite();
      this.$nextTick(async () => {
        await this.loadInfinite();
        this.initloading = false;
        this.calcHeight();
        this.loading = false;
      })
    }
    ,
    async wakeUp(data) {
      data = data ? data : this.value;
      // _log_("test.R.", this.tableData);
      this.lastScroll = 0;
      this.lastIdxClicked = null;
      this.lastLoadedTime = 0;
      this.hiddenRows = {};
      this.tableData = [];
      this.doneLoading = false;
      this.dWindowTop = null;
      this.gap.top = 0;
      this.topIdx = 0;
      this.gap.bottom = 0;
      this.dWindowBottom = null;

      this.pagingCounter = 0;
      _log_("test..", data);
      this.editingCoord = {col: null, row: null};
      this.appendTrackedData(data);
      this.initloading = false;
      this.coolDown = 15;
      const vm = this;
      this.$nextTick(() => {
        vm.loading = false;
      });
    }
    ,
    async loadInfinite(go, noPaggination) {
      const vm = this;
      _log_(
          "checking....load",
          this.query,
          this.pagingCounter
      );
      if (this.doneLoading) return;
      if (
          this.tableData &&
          this.tableData.length &&
          this.tableData.length < (this.pagingCounter + 1) * this.pagging
      ) {
        // _log_("checking go away");
        return;
      }
      if (this.loading) return false;
      this.loading = true;
      this.initloading = true;
      if ((!this.query || !this.query.sort) && this.defaultSort)
        this.query.sort = this.defaultSort;
      if (!go) {
        this.tableData = [];
        //fressh start

        let data = await this.getServData({
          ...this.query,
          ...this.controlQueryParams,
          limit: this.lazyLoadEnabled ? this.pagging : this.maxRows,
          start: 0
        });
        _log_("check.go..more.3333..." + this.pagging, this.lazyLoadEnabled, data);
        if (!data.results || data.results.length < this.pagging)
          this.doneLoading = true;
        else this.doneLoading = false;
        this.appendTrackedData(data.results);
        if (data) this.$emit("dataFetched", data);
        // this.tableData = data.results;
        this.loading = false;
        this.initloading = false;
        return true;
      }

      // if (!goAnyWay && !this.viewIndexer["infinite"]) return;
      if (!noPaggination) ++this.pagingCounter;
      _log_(
          "checking..noPaggination..load", this.query,
          this.controlQueryParams
      );
      let data = await this.getServData({
        ...this.query,
        ...this.controlQueryParams,
        limit: this.pagging,
        start: this.pagingCounter * this.pagging
      });
      _log_("checking.go..more.2222..." + this.pagging, data.results);
      if (data.results && data.results.length) {
        if (data.results.length < this.pagging) this.doneLoading = true;
        else this.doneLoading = false;
        this.appendTrackedData(data.results ? data.results : data);
        // this.tableData = [...this.tableData, ...data.results];
        // this.changeWIndow();
      }
      if (data) this.$emit("dataFetched", data);
      this.initloading = false;
      this.coolDown = 15;
      this.$nextTick(() => {
        vm.loading = false;
      });

      return true;
    }
    ,
    removeRow(rowSelector, exactMatch) {
      if (!exactMatch) {
        var newrowSelector = {};
        newrowSelector[this.rowKeyField] = rowSelector[this.rowKeyField];
        rowSelector = newrowSelector;
      }
      _log_("addd..delete", rowSelector);
      if (this.tableData && this.tableData.length)
        this.tableData = this.removeFromArray(this.tableData, rowSelector);
      // _log_("addd..aft", this.tableData);
    }
    ,
    updateOrAppendRow(updateData) {
      _log_("SELECTOR:", updateData);
      var rowSelector = {};
      if (!this.rowKeyField) {
        console.error(
            "NO rowKeyField specified. You can use updateRow(rowSelector, updateData, orAppend) for alternative much"
        );
        return;
      }
      rowSelector[this.rowKeyField] = updateData[this.rowKeyField];

      var append = !this.findInArray(this.tableData, rowSelector);

      if (append) this.appendTrackedData(updateData);
      else {
        if (this.tableData && this.tableData.length)
          this.tableData = this.updateArray(
              this.tableData,
              rowSelector,
              updateData
          );
      }
      // _log_("addd..aft", this.tableData);
    }
    ,
    async reloadRowModx(rowSelector) {
      // if(!rowSelector) {rowSelector[this.rowKeyField]}
      const data = await this.getServData({
        ...this.query,
        ...rowSelector,
        limit: 1
      });
      // _log_("addd..aft", rowSelector, data);
      if (data.results && data.results[0])
        this.updateRow(rowSelector, data.results[0]);
    }
    ,
    rn(rowSelector, updateData, orAppend) {
      var whatSelect = {};
      if (!updateData) {
        updateData = rowSelector;
        whatSelect[this.rowKeyField] = updateData[this.rowKeyField];
      } else whatSelect = rowSelector;

      // _log_("addd..befor", this.tableData);
      var append = false;
      if (orAppend) {
        append = !this.findInArray(this.tableData, whatSelect);
      }
      if (append) this.appendTrackedData(updateData);
      else if (this.tableData && this.tableData.length)
        this.tableData = this.updateArray(
            this.tableData,
            whatSelect,
            updateData
        );
      // _log_("addd..aft", this.tableData, whatSelect, updateData);
    }
    ,
    brinkOnViewOrAppend(data, selector) {
      const vm = this;
      // this.$nextTick(() => {
      // _log_("INNNN.NEW..?", vm.dataWindow);
      if (!this.dataWindow || !vm.dataWindow.length) return;
      const o = this.findInArray(vm.dataWindow, selector);
      // _log_("FFFFFFFFFFFFaddd.NEW..?", o, data);
      // this.appendTrackedData(data, true);
      // });
      if (!o) this.appendTrackedData(data, true);
    }
    ,
    getRow(selector) {
      return this.findInArray(this.tableData, selector);
    }
    ,
    appendTrackedData(data, onTop) {
      _log_("addd.NEW..?", onTop, data, this.tableData);
      if (!data) return null;
      if (!_.isArray(data)) data = [data];
      if (!this.tableData) this.tableData = [];

      const vm = this;
      let idx = 0,
          addLine = false;
      if (vm.tableData.length) {
        let last = vm.tableData[vm.tableData.length - 1];
        if (isNaN(last.idx)) last = vm.tableData[vm.tableData.length - 2]; //it may be the gap
        idx = last ? last.idx + 1 : 0;
      }
      if (!idx) idx = this.pagingCounter * this.pagging;
      if (!idx) idx = 1;
      if (onTop) {
        --this.topIdx;
        idx = this.topIdx;
      }
      if (this.simpleLazyLoader && vm.tableData.length) {
        const le = vm.tableData[vm.tableData.length - 1];
        if (le.idx == "gapbottom")
          vm.tableData.splice(vm.tableData.length - 1, 1);
      }
      data.forEach(d => {
        vm.$set(d, "idx", idx); // d.idx = idx;
        this.$set(d, '_selected', this.selectStorage ? !!this.$store.state.helpers.general_store[this.selectStorage]?.[d[this.rowKeyField]] : false)
        if (!vm.allwaysEdit) d.height = vm.rowHeight;
        // vm.viewIndexer[idx] = false;
        ++idx;
        // _log_("addd...?", d);

        // if (onTop) vm.tableData.unshift(d);
        // else vm.tableData.push(d);
      });
      if (onTop) this.tableData = [...data, ...this.tableData]
      else this.tableData = [...this.tableData, ...data]
      if (this.addEmptyLineIfEmpty) {
        if (
            !vm.tableData.length ||
            (vm.tableData[0] && vm.tableData[0].idx == "gapbottom")
        )
          this.goAddNewLine(true);
      } else this.goAddNewLine();

      if (!this.allwaysEdit && this.simpleLazyLoader)
        vm.tableData.push({idx: "gapbottom", hidden: true, height: 10});
      if (this.$refs.stable) this.$refs.stable.doLayout();
    }
    ,
    goAddNewLine(force) {
      // _log_(">ADDING LINE>>>A2>>", this.tableData, this.newRowData);
      const vm = this;
      var addLine = false;
      force = false
      // if (!this.tableData.length) return;
      if ((this.addEmptyLine || force) && !this.editDisabled) {
        if (this.rowKeyField) {
          var element = this.tableData[this.tableData.length - 1];
          //eiter line dont exist or there is a line last that has value id
          if (!element || element[this.rowKeyField]) addLine = true;
        } else if (this.tableData.length) {
          //the old way
          var element = this.tableData[this.tableData.length - 1];
          var countCols = 0,
              countEmpty = 0;
          vm.colDefinitionsProcessed.forEach(col => {
            ++countCols;
            //check if there is already an empty line
            if (
                !element[col.prop] ||
                element[col.prop] == "" ||
                element[col.prop] == 0
            )
              ++countEmpty;
          });
          if (countCols != countEmpty) addLine = true;
        } else addLine = true;
      }
      if (addLine) {
        var nullO = {idx: this.tableData.length, ...this.newRowData};
        vm.colDefinitionsProcessed.forEach(col => {
          nullO[col.prop] = !nullO[col.prop] ? "" : nullO[col.prop];
        });
        _log_(">>>>A2>>", nullO);
        // nullO.idx=this.tableData.length
        this.appendTrackedData([nullO]);
        // this.tableData.push(nullO);
      }
    }
    ,
    linkFactory(val, colDefs, row) {
      const vm = this;
      //  _log_('check..'+row.idx)
      if (!row || (row.idx && (row.idx + "").indexOf("gap") === 0)) return;
      else if (colDefs.link)
        return colDefs.link(val, colDefs, row, vm, this.tableData);
      return;
    }
    // ,
    // displayVal(val, colDefs, row) {
    //   const vm = this;
    //
    //   if (!row || (row.idx && (row.idx + "").indexOf("gap") === 0)) return;
    //   if (colDefs.formatterType == "unxToDate") return this.formatDate(val);
    //   else if (colDefs.formatter) {
    //     return colDefs.formatter(val, colDefs, row, vm, this.tableData);
    //   }
    //   if (val === null || val === undefined) return "&nbsp;";
    //   if (colDefs.labelProp) val = row(colDefs.labelProp);
    //
    //   const editor = colDefs.editorcomponent;
    //   if (editor)
    //     switch (editor.is) {
    //       case "s-select":
    //         if (!val || val == "" || val == 0) return "&nbsp;";
    //         if (editor.valueProp == "raw") return val;
    //         var avOptions = null;
    //         if (editor.optionsRepo) {
    //           avOptions = this.getList(editor.optionsRepo);
    //         } else avOptions = editor.options;
    //
    //         var q = {};
    //         q[editor.valueProp] = val + "";
    //         var o = _.find(avOptions, q);
    //         if (o) return o[editor.labelProp];
    //         else {
    //           q[editor.valueProp] = val;
    //           o = _.find(avOptions, q);
    //           if (o) return o[editor.labelProp];
    //         }
    //         return "?" + val;
    //         break;
    //
    //       default:
    //         break;
    //     }
    //
    //   return val && val != "" ? val : "<div> &nbsp;</div>";
    // }
    ,
    columnEditableIndex(rowScope, columns) {
      let colIndex = -1,
          wColname = rowScope.column.prop ? rowScope.column.prop : rowScope.column.property; // _.findIndex(columns, { prop: rowScope.column.property })

      for (let index = 0; index < columns.length; index++) {
        const col = columns[index];
        if (this.canBeEdit(col, rowScope)) {
          //  _log_('???for col...', wColname,col.prop)
          // if (this.canBeEdit(col, rowScope)) {
          ++colIndex;
          if (col.prop == wColname) {
            // _log_('???for col...', wColname)
            return colIndex;
          }
        }
      }
      //elements table hellper
      return -1;
    }
    ,
    getCoordinates(rowScope, columns) {
      const ci = this.columnEditableIndex(rowScope, columns);

      // _log_("is ins..C." + ci, rowScope.row.idx);
      //elements table hellper
      return {row: rowScope.row.idx, col: ci};
    }
    ,
    isFocushed(coordinates, rowScope, columns) {
      // _log_("is ins..C.", coordinates, rowScope, columns);
      let ci = this.columnEditableIndex(rowScope, columns);

      const b = ci >= 0 && coordinates.row == rowScope.row.idx && coordinates.col == ci;
      if (b) _log_("is ins..isFocushed.", b, ci, rowScope.row.idx, coordinates);
      return b;
    }
    ,
    calcHeight() {
      const vm = this;
      _log_(
          "hell height.999.",
          vm.heightWish,

          vm.topOffset
      );
      if (!vm.heightWish) {
        vm.optimalHeight = "";
        return;
      }
      Vue.nextTick(function () {
        if (!vm.$refs.stable) return;
        const domEl = vm.$refs.stable.$el;
        var rect = domEl ? domEl.getBoundingClientRect() : null;
        vm.query = vm.rQuery;

        if (vm.isTouchDevice()) {
          Vue.nextTick(function () {
            vm.optimalHeight = Math.round(window.innerHeight - rect.top - 5);
            if (vm.optimalHeight < 300) vm.optimalHeight = "100vh";
            // _log_("hell height.." + window.innerHeight);
            // vm.optimalHeight = window.innerHeight; //  - this.topOffset
            vm.$refs.stable.doLayout();
          });

          return;
        } else {
          if (vm.heightWish == "tobottom") {
            vm.optimalHeight = Math.round(
                window.innerHeight - rect.top - vm.topOffset - 10
            );
            if (vm.optimalHeight < window.innerHeight * .4) vm.optimalHeight = window.innerHeight * .4
            return;
          } else {
            if (vm.heightWish.indexOf("-") == 0) {
              vm.optimalHeight =
                  window.innerHeight - rect.top + parseInt(vm.heightWish);
            } else if (vm.heightWish.indexOf("%") > 0) {
              vm.optimalHeight =
                  (window.innerHeight * parseInt(vm.heightWish)) / 100;
            } else vm.optimalHeight = parseInt(vm.heightWish);
          }
          vm.optimalHeight = vm.optimalHeight - vm.topOffset;
        }
        _log_("hell height.FINALL." + vm.optimalHeight);
      });
    }
    ,
    columnEditableCount(columns, rowScope) {
      let cols = 0; // _.findIndex(columns, { prop: rowScope.column.property })
      _log_("check editable...", columns, rowScope);
      for (let index = 0; index < columns.length; index++) {
        const col = columns[index];
        if (this.canBeEdit(col, rowScope)) ++cols;
      }
      //elements table hellper
      return cols;
    }
  }
}
;

// function columnEditableCount(columns) {
//   let cols = 0; // _.findIndex(columns, { prop: rowScope.column.property })

//   for (let index = 0; index < columns.length; index++) {
//     const col = columns[index];
//     if (col.editable) ++cols;
//   }
//   //elements table hellper
//   return cols;
// }

// //for editable table
// function columnEditableIndex(rowScope, columns) {
//   // _log_('???for col...', rowScope, columns)
//   let colIndex = -1,
//     wColname =
//       rowScope.column && rowScope.column.property
//         ? rowScope.column.property
//         : rowScope.prop; // _.findIndex(columns, { prop: rowScope.column.property })

//   for (let index = 0; index < columns.length; index++) {
//     const col = columns[index];
//     if (col.editable) {
//       ++colIndex;
//       if (col.prop == wColname) {
//         // _log_('???for col...', wColname)
//         return colIndex;
//       }
//     }
//   }
//   //elements table hellper
//   return -1;
// }
//for editable table
var visibleY = function (ele, container) {


  // The element is fully visible in the container
  const {bottom, height, top} = ele.getBoundingClientRect();
  const containerRect = container.parentElement.getBoundingClientRect();
  _log_('what? now metrs..', container.scrollTop, containerRect.height, top)
  return top <= 1504 + container.scrollTop//containerRect.top ? containerRect.top - top <= height : bottom - containerRect.bottom <= height;
};

function elementIsVisible(element, container, partial) {

  var contHeight = container.offsetHeight,
      elemTop = offset(element).top - offset(container).top,
      elemBottom = elemTop + element.offsetHeight;

  return (
      (elemTop >= 0 && elemBottom <= contHeight) ||
      (partial &&
          ((elemTop < 0 && elemBottom > 0) ||
              (elemTop > 0 && elemTop <= contHeight)))
  );
}

// checks window
function isWindow(obj) {
  return obj != null && obj === obj.window;
}

// returns corresponding window
function getWindow(elem) {
  return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
}

function eloffset(el) {
  var rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {top: rect.top + scrollTop, left: rect.left + scrollLeft};
}

// taken from jquery
// @returns {{top: number, left: number}}
function offset(elem) {
  var docElem,
      win,
      box = {top: 0, left: 0},
      doc = elem && elem.ownerDocument;

  docElem = doc.documentElement;

  if (typeof elem.getBoundingClientRect !== typeof undefined) {
    box = elem.getBoundingClientRect();
  }
  win = getWindow(doc);
  return {
    top: box.top + win.pageYOffset - docElem.clientTop,
    left: box.left + win.pageXOffset - docElem.clientLeft
  };
}
</script>
<style>
.el-table__row.clickable {
  cursor: pointer;
}

span.drag-and-drop-col {
  padding: 3px;
}

span.drag-and-drop-col i {
  font-size: 17px;
}

.el-table__row.selectedRow {
  box-shadow: 0px 0px 11px wheat;
  filter: contrast(1.3);
  /*background: rgba(243, 250, 251, 0.17) !important;*/
}

.el-table__row.selectedRow td {
  border-top: 1px solid green !important;
  border-bottom: 1px solid green !important;
}

.isDeleted td {
  opacity: 0.3;
}

.el-table__row.newRow {
  filter: contrast(1.5);
  box-shadow: 0px 0px 11px orange;
  background: rgba(243, 250, 251, 0.37) !important;
}

.el-table__row.newRow td {

  background: rgba(243, 250, 251, 0.37) !important;
}

div.clickable {
  margin-bottom: 2px;
  margin-top: 2px;
  margin-left: 1px;
  margin-right: 1px;
  padding: 2px;
  box-shadow: 0px 0px 2px;
}

td.clickable {
  padding: 3px !important;
}

td.clickable {
  /* margin-left:3px;
  margin-right:3px; */
  cursor: pointer;
  box-shadow: 0px 0px 3px grey;
}

.disabled_row.el-table__cell {
  opacity: 0.5;
  text-decoration: line-through;
}

.el-table__row.gap-row {
  /*min-height: 70px;*/
  /*height: 70px;*/
  opacity: 0;
}

td.clickable:hover {
  box-shadow: 0px 0px 1px rgb(24, 13, 13);
}

.dark tr.hover-row {
  background-color: transparent;
}

.dark .el-table__body tr.hover-row.current-row > td.el-table__cell, .el-table__body tr.hover-row.el-table__row--striped.current-row > td.el-table__cell,
.dark .el-table__body tr.hover-row.el-table__row--striped > td.el-table__cell,
.dark .el-table__body tr.hover-row > td.el-table__cell {
  background-color: rgba(6, 58, 6, 0.4);
  box-shadow: 0px 0px 1px rgb(24, 13, 13);
}

/*tr.el-table__row:hover {*/
/*  color: #0f2e00 !important;*/
/*  !*background-color: red !important;*!*/
/*  !*filter: contrast(100);*!*/
/*}*/
td.selecter div.cell {
  padding-left: 0px !important;
}

td.selecter div.cell .el-button {
  padding: 0px;
}

.r-cell,
.cell {
  width: 100%;
  height: 100%;
  min-height: 30px;
  display: block;
  text-align: right;
  /* padding: 0px !important; */
}

button.supermini {
  width: 100%;
  font-size: 11px !important;
  padding: 1px !important;
  margin: 1px !important;
}

div.nowrap {
  white-space: nowrap;
}

div.wrapwords {
  word-break: keep-all;
}

.warning div.cell {
  background-color: #7e3700 !important;
  color: white;
}

.danger div.cell {
  background-color: #f56c6c !important;
  color: white;
}

.el-table__row.responsive-row {
  box-shadow: 0px 0px 2px;
  margin-bottom: 3px;
  display: inline-grid;
  width: 100%;
  min-width: 98vw;
}

.responsive-field {
  border-bottom: 1px solid darkolivegreen;
  margin-bottom: 2px;
  margin-top: 2px;
  min-height: 20px;
  font-size: 14px;
}

.dark .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: rgb(1, 14, 10, 0.5) !important;
  filter: glow(0.5);
  color: whitesmoke;
}

button.selecter i {
  font-size: 19px;
}

.el-table__cell.editable {
  background: #23948847;
  //padding-right: 2px;
  //border-bottom: 1px dashed grey;
}

.r-cell.editable {
  background: #23948847;
  padding-right: 2px;
  //border-bottom: 1px dashed grey;
}

/*
.r-cell.no-edit {
  padding-right: 2px;
  background:  rgba(137, 155, 175, 0.438) !important;
}
 .el-table__row td {
  padding: 0px !important;
} */
</style>
